/*
 * Layout for the landlord info section
 */

define(["marionette", "./template/landlordInfoTemplate.html"], function (
  Marionette,
  LandlordInfoTemplate,
) {
  var LandlordInfoView = {
    landlordInfoLayout: Marionette.ItemView.extend({
      template: LandlordInfoTemplate,
      regions: {},
    }),
  };

  return LandlordInfoView;
});
